import { NgModule } from '@angular/core';
import { EditWeighInPage } from 'pages/edit-weigh-in/edit-weigh-in';
import { ComponentsModule } from 'components/components.module';
import { DirectivesModule } from 'directives/directives.module';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [EditWeighInPage],
    imports: [PagesModule, ComponentsModule, DirectivesModule]
})
export class EditWeighInPageModule {}
